/**
 * Map a list of records into react-select option objects, picking the label and
 * value from configurable source keys and emitting them under configurable
 * output keys.
 *
 * Defaults emit the PIM-canonical `{ name: <value>, label: <label> }` shape used
 * by the column-edit dropdowns. Pass `valueName`/`labelName` to emit a different
 * pair (e.g. `{ value, label }`), or `stringify` to coerce both fields to string
 * for selects that key on string ids.
 */
export interface ToOptionsConfig<T> {
  labelKey: keyof T;
  valueKey: keyof T;
  labelName?: string;
  valueName?: string;
  stringify?: boolean;
}

export function toOptions<T>(list: T[] | null | undefined, config: ToOptionsConfig<T>): Record<string, unknown>[] {
  if (!Array.isArray(list)) return [];
  const { labelKey, valueKey, labelName = 'label', valueName = 'name', stringify = false } = config;
  return list.map((item) => {
    const rawLabel = item[labelKey];
    const rawValue = item[valueKey];
    return {
      [valueName]: stringify ? String(rawValue) : rawValue,
      [labelName]: stringify ? String(rawLabel) : rawLabel,
    };
  });
}
